import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dResult from "../Data.Result/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic$dCoupons$dTypes from "../Restaumatic.Coupons.Types/index.js";
import * as Restaumatic$dPromotions$dTypes from "../Restaumatic.Promotions.Types/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
const $GetActivePromotionsError = () => ({tag: "InvalidCoupon"});
const GetActivePromotionsRequest = x => x;
const InvalidCoupon = /* #__PURE__ */ $GetActivePromotionsError();
const CouponPromotion = x => x;
const GetActivePromotionsResponseContent = x => x;
const GetActivePromotionsResponse = x => x;
const rPCMethodNameGetActivePro = {rpcMethodName: v => "GetActivePromotionsRequest"};
const newtypeGetActivePromotion = {Coercible0: () => {}};
const newtypeGetActivePromotion1 = {Coercible0: () => {}};
const newtypeGetActivePromotion2 = {Coercible0: () => {}};
const newtypeCouponPromotion_ = {Coercible0: () => {}};
const hasFieldGetActivePromotio = dictHasField => dictHasField;
const hasFieldGetActivePromotio1 = dictHasField => dictHasField;
const hasFieldCouponPromotion = dictHasField => dictHasField;
const eqGetActivePromotionsRequ = {eq: x => y => Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl)(x.couponCodes)(y.couponCodes) && x.restaurantId === y.restaurantId};
const eqGetActivePromotionsErro = {eq: x => y => true};
const ordGetActivePromotionsErr = {compare: x => y => Data$dOrdering.EQ, Eq0: () => eqGetActivePromotionsErro};
const eqCouponPromotion = {
  eq: x => y => x.code === y.code && x.promotionId === y.promotionId && (() => {
    if (x.source.tag === "Manual") { return y.source.tag === "Manual"; }
    if (x.source.tag === "FirstOrderDiscount") { return y.source.tag === "FirstOrderDiscount"; }
    if (x.source.tag === "Loyalty") { return y.source.tag === "Loyalty"; }
    if (x.source.tag === "Pbx") { return y.source.tag === "Pbx"; }
    if (x.source.tag === "FirstAbsenceReminder") { return y.source.tag === "FirstAbsenceReminder"; }
    if (x.source.tag === "SecondAbsenceReminder") { return y.source.tag === "SecondAbsenceReminder"; }
    if (x.source.tag === "RosPhoneOrder") { return y.source.tag === "RosPhoneOrder"; }
    if (x.source.tag === "RosPortalOrder") { return y.source.tag === "RosPortalOrder"; }
    return false;
  })()
};
const eqGetActivePromotionsResp = {
  eq: x => y => Data$dEq.eqArrayImpl(eqCouponPromotion.eq)(x.coupons)(y.coupons) && Data$dEq.eqArrayImpl(Restaumatic$dPromotions$dTypes.eqPromotion.eq)(x.promotions)(y.promotions)
};
const eqGetActivePromotionsResp1 = {
  eq: x => y => {
    if (x.tag === "Left") { return y.tag === "Left"; }
    if (x.tag === "Right") {
      if (y.tag === "Right") { return eqGetActivePromotionsResp.eq(x._1)(y._1); }
      return false;
    }
    return false;
  }
};
const genericGetActivePromotionsResponseContent = {to: x => x, from: x => x};
const genericGetActivePromotionsResponse = {to: x => x, from: x => x};
const genericGetActivePromotionsRequest = {to: x => x, from: x => x};
const showGetActivePromotionsRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Data$dShow.showStringImpl);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["couponCodes", $0(v.couponCodes)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "restaurantId",
              Data$dShow.showIntImpl(v.restaurantId)
            ]))([]));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "GetActivePromotionsRequest"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGetActivePromotionsRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "couponCodes"})({unsafeDecode: Unscramble.decodeArray(Unscramble.decodeString)})(Unscramble.decodeRecordCons({
      reflectSymbol: () => "restaurantId"
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericGetActivePromotionsError = {to: x => InvalidCoupon, from: x => Data$dGeneric$dRep.NoArguments};
const showGetActivePromotionsError = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "InvalidCoupon"});
    return x => $0["genericShow'"](Data$dGeneric$dRep.NoArguments);
  })()
};
const unscrambleDecodeGetActivePromotionsError = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericGetActivePromotionsError)({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("InvalidCoupon"), Data$dGeneric$dRep.NoArguments)]
  })(Unscramble$dEnum.defaultEnumOptions)
};
const boundedGetActivePromotion = {top: InvalidCoupon, bottom: InvalidCoupon, Ord0: () => ordGetActivePromotionsErr};
const enumGetActivePromotionsEr = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericGetActivePromotionsError)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments)),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericGetActivePromotionsError)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments)),
  Ord0: () => ordGetActivePromotionsErr
};
const boundedEnumGetActivePromo = /* #__PURE__ */ (() => (
  {
    cardinality: Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments)["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericGetActivePromotionsError)(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments)),
    fromEnum: (() => {
      const $0 = Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments);
      return x => $0["genericFromEnum'"](Data$dGeneric$dRep.NoArguments);
    })(),
    Bounded0: () => boundedGetActivePromotion,
    Enum1: () => enumGetActivePromotionsEr
  }
))();
const genericCouponPromotion = {to: x => x, from: x => x};
const showCouponPromotion = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["code", Data$dShow.showStringImpl(v.code)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "promotionId",
            Data$dShow.showIntImpl(v.promotionId)
          ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["source", Restaumatic$dCoupons$dTypes.showCouponSource.show(v.source)]))([])));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "CouponPromotion"});
    return x => $0["genericShow'"](x);
  })()
};
const showGetActivePromotionsResponseContent = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dPromotions$dTypes.showPromotion.show);
      const $1 = Data$dShow.showArrayImpl(showCouponPromotion.show);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["coupons", $1(v.coupons)]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["promotions", $0(v.promotions)]))([]));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "GetActivePromotionsResponseContent"});
    return x => $0["genericShow'"](x);
  })()
};
const showGetActivePromotionsResponse = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          if (v.tag === "Left") { return "(Left " + showGetActivePromotionsError.show(v._1) + ")"; }
          if (v.tag === "Right") { return "(Right " + showGetActivePromotionsResponseContent.show(v._1) + ")"; }
          $runtime.fail();
        })()
      ]
    })({reflectSymbol: () => "GetActivePromotionsResponse"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeCouponPromotion = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "code"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "promotionId"
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({reflectSymbol: () => "source"})(Restaumatic$dCoupons$dTypes.unscrambleDecodeCouponSource)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeGetActivePromotionsResponseContent = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "coupons"})({
      unsafeDecode: Unscramble.decodeArray(unscrambleDecodeCouponPromotion.unsafeDecode)
    })(Unscramble.decodeRecordCons({reflectSymbol: () => "promotions"})({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dPromotions$dTypes.unscrambleDecodePromotion.unsafeDecode)
    })(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeGetActivePromotionsResponse = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Data$dResult.udecodeResult(unscrambleDecodeGetActivePromotionsError)(unscrambleDecodeGetActivePromotionsResponseContent);
    return x => $0.unsafeDecode(x);
  })()
};
const encodeGetActivePromotionsRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetActivePromotionsRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "GetActivePromotionsRequest"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "restaurantId"})({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))({reflectSymbol: () => "couponCodes"})((() => {
      const $0 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
      return {encodeWithOptions: v => $0};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGetActivePromotionsError = {encode: x => "InvalidCoupon"};
const encodeCouponPromotion = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericCouponPromotion)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "CouponPromotion"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "source"
    })({encodeWithOptions: v => Restaumatic$dCoupons$dTypes.encodeCouponSource.encode}))({reflectSymbol: () => "promotionId"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({
      reflectSymbol: () => "code"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGetActivePromotionsResponseContent = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetActivePromotionsResponseContent)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "GetActivePromotionsResponseContent"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "promotions"})((() => {
      const $0 = Data$dFunctor.arrayMap(Restaumatic$dPromotions$dTypes.encodePromotion.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "coupons"})((() => {
      const $0 = Data$dFunctor.arrayMap(encodeCouponPromotion.encode);
      return {encodeWithOptions: v => $0};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeGetActivePromotionsResponse = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetActivePromotionsResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "GetActivePromotionsResponse"
  })({
    encodeArgs: opts => v => Data$dList$dTypes.$List(
      "Cons",
      Foreign$dGeneric$dClass.$Arg(
        "PlainArg",
        (() => {
          if (v.tag === "Left") { return {Left: "InvalidCoupon"}; }
          if (v.tag === "Right") { return {Right: encodeGetActivePromotionsResponseContent.encode(v._1)}; }
          $runtime.fail();
        })()
      ),
      Data$dList$dTypes.Nil
    )
  }))
};
const decodeGetActivePromotionsRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetActivePromotionsRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "GetActivePromotionsRequest"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "restaurantId"
  })({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "couponCodes"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Foreign$dGeneric$dClass.stringDecode);
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGetActivePromotionsError = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericGetActivePromotionsError)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "InvalidCoupon"
  }))
};
const decodeCouponPromotion = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericCouponPromotion)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "CouponPromotion"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "source"
  })({decodeWithOptions: v => Restaumatic$dCoupons$dTypes.decodeCouponSource.decode})())({reflectSymbol: () => "promotionId"})({
    decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)
  })())({reflectSymbol: () => "code"})({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGetActivePromotionsResponseContent = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetActivePromotionsResponseContent)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "GetActivePromotionsResponseContent"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "promotions"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dPromotions$dTypes.decodePromotion);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "coupons"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(decodeCouponPromotion);
    return {decodeWithOptions: v => $0.decode};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeGetActivePromotionsResponse = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetActivePromotionsResponse)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "GetActivePromotionsResponse"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dResult.decodeResult(decodeGetActivePromotionsError)(decodeGetActivePromotionsResponseContent);
    return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
  })())(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $GetActivePromotionsError,
  CouponPromotion,
  GetActivePromotionsRequest,
  GetActivePromotionsResponse,
  GetActivePromotionsResponseContent,
  InvalidCoupon,
  boundedEnumGetActivePromo,
  boundedGetActivePromotion,
  decodeCouponPromotion,
  decodeGetActivePromotionsError,
  decodeGetActivePromotionsRequest,
  decodeGetActivePromotionsResponse,
  decodeGetActivePromotionsResponseContent,
  encodeCouponPromotion,
  encodeGetActivePromotionsError,
  encodeGetActivePromotionsRequest,
  encodeGetActivePromotionsResponse,
  encodeGetActivePromotionsResponseContent,
  enumGetActivePromotionsEr,
  eqCouponPromotion,
  eqGetActivePromotionsErro,
  eqGetActivePromotionsRequ,
  eqGetActivePromotionsResp,
  eqGetActivePromotionsResp1,
  genericCouponPromotion,
  genericGetActivePromotionsError,
  genericGetActivePromotionsRequest,
  genericGetActivePromotionsResponse,
  genericGetActivePromotionsResponseContent,
  hasFieldCouponPromotion,
  hasFieldGetActivePromotio,
  hasFieldGetActivePromotio1,
  newtypeCouponPromotion_,
  newtypeGetActivePromotion,
  newtypeGetActivePromotion1,
  newtypeGetActivePromotion2,
  ordGetActivePromotionsErr,
  rPCMethodNameGetActivePro,
  showCouponPromotion,
  showGetActivePromotionsError,
  showGetActivePromotionsRequest,
  showGetActivePromotionsResponse,
  showGetActivePromotionsResponseContent,
  unscrambleDecodeCouponPromotion,
  unscrambleDecodeGetActivePromotionsError,
  unscrambleDecodeGetActivePromotionsRequest,
  unscrambleDecodeGetActivePromotionsResponse,
  unscrambleDecodeGetActivePromotionsResponseContent
};
